
/* ===== Page: Home ===== */
import { useEffect } from 'react';
import MainLayout from '@/components/Layout/MainLayout';
import Hero from '@/components/Home/Hero';
import AboutSection from '@/components/Home/AboutSection';
import SolutionsSection from '@/components/Home/SolutionsSection';
import FeatureVisualization from '@/components/Home/FeatureVisualization';
import IndustriesSection from '@/components/Home/IndustriesSection';
import TestimonialsSection from '@/components/Home/TestimonialsSection';
import SecurityVisualization from '@/components/Home/SecurityVisualization';
import TeamNote from '@/components/Home/TeamNote';
import FAQSection from '@/components/Home/FAQSection';
import { industries, solutions, testimonials } from '@/components/Home/data';

// Update the solutions data with valid image paths that exist in the project
const updatedSolutions = [
  {
    ...solutions[0],
    image: '/images/Solutions Fibre Hero 1.png'  
  },
  {
    ...solutions[1],
    image: '/images/Solutions Fence - New Build 1.png'  
  },
  {
    ...solutions[2],
    image: '/images/Solutions-Bespoke-Case-Studies-Solar-Farm-Remote-1.png'  
  }
];

/**
 * @component Index
 * @description Home page component with hero section, trust indicators, and various informational sections
 * @returns {JSX.Element} Complete homepage within MainLayout
 */
const Index = () => {
  /**
   * Initialize animations for page elements
   * Adds animation classes to elements with specific selectors
   * Sets up IntersectionObserver for scroll animations
   */
  useEffect(() => {
    // Add animation class to hero section elements
    const heroElements = document.querySelectorAll('.hero-animate');
    heroElements.forEach((element, index) => {
      setTimeout(() => {
        element.classList.add('opacity-100', 'translate-y-0');
      }, 200 + index * 200);
    });

    // Activate stagger animations for sections that are in viewport on load
    const animateOnView = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          animateOnView.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });
    document.querySelectorAll('.animate-on-view').forEach(section => {
      animateOnView.observe(section);
    });
  }, []);
  
  return <MainLayout>
      <div className="home-theme bg-[#f5f0ff]/[0.54]">
        {/* Hero section with specified background video and fallback image */}
        <Hero 
          backgroundVideo="/videos/forti-fi logo video slower.mp4" 
          backgroundImage="/images/hero-section-home-page-2.png" // Fallback if video fails or for poster
        />
        
        {/* About section - Company overview */}
        <AboutSection />
        
        {/* Solutions section - Product/service offerings */}
        <SolutionsSection solutions={updatedSolutions} />
        
        {/* Feature visualization - Interactive display of features */}
        <FeatureVisualization />
        
        {/* Industries section - Target markets */}
        <IndustriesSection industries={industries} />
        
        {/* Testimonials section - Client feedback */}
        <TestimonialsSection testimonials={testimonials} />
        
        {/* Security visualization - Visual explanation of security features */}
        <SecurityVisualization />
        
        {/* FAQ Section - Common questions and answers */}
        <FAQSection />
        
        {/* Team note - Personal message from the team */}
        <TeamNote />
      </div>
    </MainLayout>;
};
export default Index;
